import React from "react";
import {Box, Button, Stack} from "@mui/material";

export const AltroQuestion = () => {
  return(
      <Stack mt={4} justifyContent={'center'} alignItems={'center'}>
          <Button variant={'contained'} href={"https://real-time-report.plesh.co/sgde"} target={'_blank'}>
              VAI AL REPORT
          </Button>
      </Stack>
  )
}